var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.33301C10.2091 9.33301 12 7.54215 12 5.33301C12 3.12387 10.2091 1.33301 8 1.33301C5.79086 1.33301 4 3.12387 4 5.33301C4 7.54215 5.79086 9.33301 8 9.33301Z",
    stroke: "#585A5B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.33301C9.10457 7.33301 10 6.43758 10 5.33301C10 4.22844 9.10457 3.33301 8 3.33301C6.89543 3.33301 6 4.22844 6 5.33301C6 6.43758 6.89543 7.33301 8 7.33301Z",
    stroke: "#585A5B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.33301V13.9997",
    stroke: "#585A5B",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map_pin.355479d926ceac30f91bf0a2f915d611.svg";
export { ForwardRef as ReactComponent };